var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-min-sida-white';
                    var viewUrl = 'gfx/sprite.svg#view-icon-min-sida-white';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };